import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  Box,
} from '@chakra-ui/react';
import { useGeneralContext } from '../components/GeneralContext.js';
import Header from '../components/Header.jsx';
import theme from '../theme.js';

const Rules = () => {
  const { rules, fetchRules } = useGeneralContext();
  const [parsedRules, setParsedRules] = useState(rules);
  const location = useLocation();
  const [openPath, setOpenPath] = useState([]);

  function SectionList({ sections }) {
    if (!Array.isArray(sections)) return null;
    return (
      <div>
        {sections.map(sec => (
          <Accordion
            key={sec.id}
            allowToggle
            margin={5}
            _expanded={true}
            defaultIndex={openPath.includes(sec.id.slice(1)) ? [0] : []}
          >
            <AccordionItem>
              <h2>
                <AccordionButton
                  _expanded={{ bg: theme.colors.leftSideLight }}
                  bg={theme.colors.neutralLight}
                >
                  <Box
                    as="span"
                    flex="1"
                    textAlign="left"
                    fontWeight="bold"
                    fontSize="20"
                  >
                    {sec.title}
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4} style={{ whiteSpace: 'pre-line' }}>
                <Link to={`/rules#${sec.id}`} />
                {sec.description}
                {sec.subsections?.length > 0 && (
                  <SectionList sections={sec.subsections} />
                )}
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        ))}
      </div>
    );
  }

  useEffect(() => {
    fetchRules();
    if (location.hash && parsedRules) setOpenPath(location.hash.slice(1));
    setParsedRules(rules);
  }, [fetchRules, location.hash, parsedRules, rules]);

  return (
    <div className="p-4">
      {parsedRules && (
        <>
          <Header pageHeader={'Rules Page'} />
          <SectionList sections={parsedRules} />
        </>
      )}
    </div>
  );
};

export default Rules;
